import React from "react";
import vcfiocn from "../../assets/img/vcard icon2.png";
const WhyUs = () => {
  return (
    <>
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div
            className="col-lg-6 order-1 order-lg-2 bordert"
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <div className=" center">
              <h1 id="roboto">HERE'S BENEFIT OF NETNEXA</h1>
            </div>
            <p id='roboto' className="fst-italic center sideline">
              "NetNexa empowers with job opportunities, 
              fostering connections for financial growth. 
              Join us to revolutionize student job access and networking for financial ease"
            </p>
            <div className="center"><a href="#" ><button className="btn-get-started">Join Our Community</button></a></div>
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
        
            <div className="center">
              
              <img
                width="200px"
                className="bordert"
                src={vcfiocn}
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="center">
        <hr
          style={{
            width: "20%",
            color: "black",
            marginTop: "80px",
            boxShadow: "#021509",
          }}
        />
      </div>
    </>
  );
};

export default WhyUs;
